'use client';

import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postAppointment, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, labelStyles, renderReportfield, renderTableTD, renderTableTH} from '../../utils/templateUtils';
import './postPrescription.scss';

export default function PostP4PrescriptionTemplate(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const [unit, setUnit] = useState('MG');
  const units = ['MG', 'ML'];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  // 12-hour time format state variables
  const [timeOfFetHour, setTimeOfFetHour] = useState('');
  const [timeOfFetMinute, setTimeOfFetMinute] = useState('');
  const [timeOfFetPeriod, setTimeOfFetPeriod] = useState('AM');

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'medication', label: 'Medication'},
    {key: 'dose', label: 'Dose'},
    {key: 'frequency', label: 'Frequency / Time'},
    {key: 'route', label: 'Route'},
    {key: 'food', label: 'Food'},
    {key: 'notes', label: 'Notes'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: 1,
      medication: 'Tab. Progynova',
      dose: '2 mg',
      frequency: '1-1-1 (8AM–3PM–8PM)',
      route: 'Oral',
      food: 'After food',
      notes: 'FROM: ____'
    },
    {
      sno: 2,
      medication: 'Tab. Intafol-D / Folvista / Folmpt',
      dose: '–',
      frequency: '1-0-0',
      route: 'Oral',
      food: 'After food',
      notes: 'FROM: ____'
    },
    {
      sno: 3,
      medication: 'Tab. Ecosprin 75/150',
      dose: '-',
      frequency: '0-0-1',
      route: 'Oral',
      food: 'in the night after meal',
      notes: 'FROM: ____'
    },
    {
      sno: 4,
      medication: 'Tab. Dydrofirst',
      dose: '10 mg',
      frequency: '1-1-1',
      route: 'Oral',
      food: 'After food',
      notes: 'FROM: ____'
    },
    {
      sno: 5,
      medication: 'Cap. GESTOBOND',
      dose: '400 mg',
      frequency: '1-0-1 (10AM–10PM)',
      route: 'Vaginal',
      food: 'After food',
      notes: 'FROM: ____'
    },
    {
      sno: 6,
      medication: 'Inj. STRONE AQ',
      dose: '50 mg',
      frequency: 'Daily once or twice daily',
      route: 'IM',
      food: '–',
      notes: 'FROM: ____'
    },
    {
      sno: 7,
      medication: '💉 Inj. GESTONE',
      dose: '100 mg',
      frequency: 'Daily till ET; Post-ET alternate days',
      route: 'IM',
      food: '–',
      notes: 'FROM: ____Total vials: 14'
    },
    {
      sno: 8,
      medication: 'Inj. Dispovan',
      dose: '2.5 mL',
      frequency: 'As needed',
      route: '–',
      food: '–',
      notes: ' '
    },
    {
      sno: 9,
      medication: 'Tab. HCQ',
      dose: '200 mg',
      frequency: '1-0-1',
      route: 'Oral',
      food: 'After food',
      notes: 'FROM: ____'
    },
    {
      sno: 10,
      medication: 'Tab. Wysolone',
      dose: '10 mg',
      frequency: '1-0-1',
      route: 'Oral',
      food: 'After food',
      notes: 'FROM: ____'
    },
    {
      sno: 11,
      medication: 'Inj. HCG (HUCOG)',
      dose: '5000 IU',
      frequency: 'Every 5 days',
      route: 'IM',
      food: '–',
      notes: 'As advised'
    },
    {
      sno: 12,
      medication: 'Tab. Thyronorm / Lethyrox',
      dose: '–',
      frequency: '1-0-0',
      route: 'Oral',
      food: 'Empty stomach',
      notes: 'FROM: ____'
    },
    {
      sno: 13,
      medication: 'Tab. Glycomet SR',
      dose: '500 mg',
      frequency: '1-0-1',
      route: 'Oral',
      food: 'After food',
      notes: 'FROM: ____'
    },
    {
      sno: 14,
      medication: 'Inj. Enoxaparin (Evaparin)',
      dose: '40/60 mg',
      frequency: 'Daily once / Alternate days',
      route: 'SC',
      food: '–',
      notes: 'FROM: ____'
    },
    {
      sno: 15,
      medication: 'Intralipid',
      dose: '250 mL IV',
      frequency: '1. After ET\n2. After β-hCG positive',
      route: 'IV',
      food: '-',
      notes: 'Infuse 2–3 hrs'
    },
    {
      sno: 16,
      medication: 'Bharglob / IVIG',
      dose: '2 g/kg OR 10 g',
      frequency: '1. After ET\n2. After β-hCG positive',
      route: 'IV',
      food: '-',
      notes: 'As indicated'
    },
    {
      sno: 17,
      medication: 'Thymosine Alpha-1',
      dose: '1.6 mg SC',
      frequency: 'Weekly',
      route: 'SC',
      food: '-',
      notes: 'Start post-ET; continue per protocol'
    }
  ]);

  const [showTables, setShowTables] = useState({
    medicationChart: true
  });

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            setFormData({
              ...formData,
              patientName: namePat,
              age: data?.age,
              gender: data?.gender,
              patientId: text
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        setFormData({
          ...formData,
          patientId: e.target.value
        });
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData?.p_uhid || formData.patientId,
          name: props.patientsData?.titles ? `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}` : formData.patientName,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('PostP4PrescriptionReportGenerateWrap').innerHTML;

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Post P4 Prescription'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='PostP4Prescription'>
      <div className='PostP4PrescriptionTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage || '/placeholder.svg'}
              style={{
                width: '100%',
                margin: '0 auto'
              }}
            />
          </div>
          <h2 style={{display: 'flex', justifyContent: 'space-between'}}>
            ASCAS – POST-P4 & POST-ET PRESCRIPTION
            {/* <span>
              Date{" "}
              <input
                type="date"
                className={`createTime ${show ? "hide" : "show"}`}
                name="date"
                onChange={(e) => handleChange(e, "date")}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>&nbsp;{formData.date}</span>
            </span> */}
          </h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>

        <div className='detail'>
          <h3 className='mt-4 mb-3'>P4 Details</h3>
          <div className='row mb-3'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='P4 Value (ng/mL) :' name='p4Value' value={formData.p4Value} onChange={handleChange} show={true} minWidth='180px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='ET Thickness on P4 Day (mm) :' name='etThickness' value={formData.etThickness} onChange={handleChange} show={true} minWidth='180px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='P4 Start :'
                name='p4StartDate'
                value={formData.p4StartDate}
                onChange={handleChange}
                show={true}
                inputType='date'
                minWidth='140px'
                type='date'
                className={`createTime ${show ? 'hide' : 'show'}`}
              />
            </div>
          </div>

          <div className='row mb-3'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='FET Date :'
                name='dateOfFet'
                value={formData.dateOfFet}
                onChange={handleChange}
                show={true}
                inputType='date'
                type='date'
                className={`createTime ${show ? 'hide' : 'show'}`}
                minWidth='180px'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Place :' name='placeOfFet' value={formData.placeOfFet} onChange={handleChange} show={true} minWidth='180px' />
            </div>
            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label htmlFor='timeOfFet' className='mb-0 fw-semibold' style={{minWidth: '150px'}}>
                  Time :
                </label>
                {!show ? (
                  <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <input
                      type='number'
                      min='1'
                      max='12'
                      placeholder='hh'
                      name='timeOfFetHour'
                      value={timeOfFetHour || ''}
                      onChange={e => setTimeOfFetHour(e.target.value)}
                      style={{width: '50px', textAlign: 'center', border: '1px solid #b0a4a4ff', outline: 'none', padding: '10px'}}
                    />
                    <span>:</span>
                    <input
                      type='number'
                      min='0'
                      max='59'
                      placeholder='mm'
                      name='timeOfFetMinute'
                      value={timeOfFetMinute || ''}
                      onChange={e => setTimeOfFetMinute(e.target.value)}
                      style={{width: '50px', textAlign: 'center', border: '1px solid #b0a4a4ff', outline: 'none', padding: '10px'}}
                    />
                    <select
                      name='timeOfFetPeriod'
                      value={timeOfFetPeriod || ''}
                      onChange={e => setTimeOfFetPeriod(e.target.value)}
                      style={{width: '80px', border: '1px solid #b0a4a4ff', outline: 'none', padding: '10px'}}>
                      <option value='AM'>AM</option>
                      <option value='PM'>PM</option>
                    </select>
                  </div>
                ) : (
                  <span style={{fontSize: '14px'}}>
                    {timeOfFetHour && timeOfFetMinute && timeOfFetPeriod ? `${timeOfFetHour}:${timeOfFetMinute.toString().padStart(2, '0')} ${timeOfFetPeriod}` : ''}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className='row mb-3'>
            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label htmlFor='trialCannulation' className='mb-0 fw-semibold' style={{minWidth: '180px'}}>
                  Trial Cannulation :
                </label>
                <select id='trialCannulation' name='trialCannulation' className='form-select' value={formData.trialCannulation} onChange={handleChange}>
                  <option value=''>Please Select</option>
                  <option value='EASY'>Easy</option>
                  <option value='DIFFICULT'>Difficult</option>
                </select>
              </div>
            </div>

            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label htmlFor='trialCannulation' className='mb-0 fw-semibold' style={{minWidth: '180px'}}>
                  Anesthesia:
                </label>
                <select id='anesthesia' name='anesthesia' className='form-select' value={formData.anesthesia} onChange={handleChange}>
                  <option value=''>Please Select</option>
                  <option value='Ga'>Ga</option>
                  <option value='Concious'>Concious</option>
                </select>
              </div>
            </div>
          </div>

          <h3 className='mt-4 mb-3'>Embryo Details</h3>

          <div className='row mb-3'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Cycle No :' name='cycleNumber' value={formData.cycleNumber} onChange={handleChange} show={true} minWidth='180px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Embryos Frozen :' name='embryosFrozen' value={formData.embryosFrozen} onChange={handleChange} show={true} minWidth='180px' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Thaw :' name='embryosToThaw' value={formData.embryosToThaw} onChange={handleChange} show={true} minWidth='180px' />
            </div>
          </div>

          <div className='row mb-3'>
            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2 w-100' style={{fontSize: '18px'}}>
                <label htmlFor='specialInstructions' className='mb-0 fw-semibold' style={{minWidth: '180px'}}>
                  Special Instructions:
                </label>

                <select id='specialInstructions' name='specialInstructions' className='form-select' value={formData.specialInstructions} onChange={handleChange}>
                  <option value=''>Please Select</option>
                  <option value='LAH'>LAH</option>
                  <option value='EMBRYO GLUE'>EMBRYO GLUE</option>
                </select>
              </div>
            </div>

            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label htmlFor='antibioticNeeded' className='mb-0 fw-semibold' style={{minWidth: '180px'}}>
                  Allis/Stylet :
                </label>
                <select id='antibioticNeeded' name='antibioticNeeded' className='form-select' value={formData.antibioticNeeded} onChange={handleChange}>
                  <option value=''>Please Select</option>
                  <option value='YES'>YES</option>
                  <option value='NO'>NO</option>
                </select>
              </div>
            </div>

            <div className='col-md-4'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label htmlFor='eraTestDone' className='mb-0 fw-semibold' style={{minWidth: '180px'}}>
                  ERA :
                </label>
                <select id='eraTestDone' name='eraTestDone' className='form-select' value={formData.eraTestDone} onChange={handleChange}>
                  <option value=''>Please Select</option>
                  <option value='YES'>YES</option>
                  <option value='NO'>NO</option>
                </select>
              </div>
            </div>
          </div>

          <h3 className='mt-4 mb-3'>Comorbidities</h3>
          <div className='row mb-4'>
            <div className='col-md-6' style={{fontSize: '18px'}}>
              <div className='d-flex align-items-center gap-2 w-100'>
                <label htmlFor='comorbidities' className='mb-0 fw-semibold' style={{minWidth: '180px'}}>
                  Comorbidities:
                </label>
                {formData.comorbidities === 'OTHERS' ? (
                  <input type='text' name='otherComorbidities' placeholder='Enter other comorbidities' className='createTime' value={formData.otherComorbidities || ''} onChange={handleChange} />
                ) : (
                  <select id='comorbidities' name='comorbidities' className='form-select' value={formData.comorbidities} onChange={handleChange}>
                    <option value=''>Please select</option>
                    <option value='HT'>HT</option>
                    <option value='DM'>DM</option>
                    <option value='THYROID'>THYROID</option>
                    <option value='OTHERS'>OTHERS</option>
                    <option value='NIL'>NIL</option>
                  </select>
                )}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='d-flex align-items-center gap-2' style={{fontSize: '18px'}}>
                <label htmlFor='medication' className='mb-0 fw-semibold' style={{minWidth: '180px'}}>
                  Medication:
                </label>
                <input type='text' id='medication' name='medication' className='createTime' value={formData.medication || ''} onChange={handleChange} />
              </div>
            </div>
            {/* <div className="col-md-6"> */}
            {/* <div className="d-flex align-items-start" style={{ gap: "10px" }}>
                <label
                  htmlFor="medicationsForAbove"
                  className="fw-bold"
                  style={{ whiteSpace: "nowrap", paddingTop: "6px", minWidth: "180px" }}
                >
                  Medications for Above:
                </label>
                <textarea
                  className="Textarea"
                  placeholder="Medications for comorbidities"
                  id="medicationsForAbove"
                  name="medicationsForAbove"
                  value={formData.medicationsForAbove || ""}
                  onChange={handleChange}
                  rows="3"
                  style={{ width: "100%" }}
                />
              </div>
            </div> */}
          </div>
        </div>

        {showTables.medicationChart && (
          <TemplateTable
            id='medicationChart'
            title='Medication Chart'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medicationChart', setShowTables)}
          />
        )}



        <div className='bulletin'>
          <h4 className='mt-3 mb-2'>FOOTER – GESTONE PAIN MANAGEMENT</h4>
          <ul style={{paddingLeft: '20px', margin: '5px 0'}}>
            <li>Ice pack 5–10 min before & after injection</li>
            <li>Warm compress later for muscle relaxation</li>
            <li>Inject slowly; gentle massage helps</li>
            <li>Rotate both buttocks; avoid same site</li>
            <li>Mild Diclofenac gel if painful</li>
            <li>Report swelling, redness, or hard lump</li>
          </ul>
        </div>

        <div className='d-flex align-items-start py-2' style={{gap: '10px'}}>
          <label htmlFor='advice' className='fw-bold' style={{whiteSpace: 'nowrap', paddingTop: '6px'}}>
            ADVICE:
          </label>
          <textarea className='Textarea' placeholder='Enter advice' id='advice' name='advice' value={formData.advice || ''} onChange={handleChange} rows='4' cols='100' />
        </div>

        <p className='pt-3' style={{display: 'flex', alignItems: 'center', fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      <div id='PostP4PrescriptionReportGenerate'>
        <div id='PostP4PrescriptionReportGenerateWrap'>
          <Headers />
          <p className='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>P4 DETAILS</h4>
          </div>

          <div style={{display: 'flex', marginTop: '10px', flexWrap: 'wrap'}}>
            {renderReportfield('P4 Value :', `${formData.p4Value ? formData.p4Value + ' ng/mL' : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('ET Thickness on P4 Day :', `${formData.etThickness ? formData.etThickness + ' mm' : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('P4 Start :', `${formData.p4StartDate ? formData.p4StartDate.split('-').reverse().join('-') : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('FET Date :', `${formData.dateOfFet ? formData.dateOfFet.split('-').reverse().join('-') : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Place :', `${formData.placeOfFet ? formData.placeOfFet : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Time :', `${timeOfFetHour && timeOfFetMinute && timeOfFetPeriod ? `${timeOfFetHour}:${timeOfFetMinute.toString().padStart(2, '0')} ${timeOfFetPeriod}` : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Trial Cannulation :', `${formData.trialCannulation ? formData.trialCannulation : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Anesthesia :', `${formData.anesthesia ? formData.anesthesia : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>Embryo Details</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px', flexWrap: 'wrap'}}>
            {renderReportfield('Cycle No. :', `${formData.cycleNumber ? formData.cycleNumber : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Embryos Frozen :', `${formData.embryosFrozen ? formData.embryosFrozen : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Thaw :', `${formData.embryosToThaw ? formData.embryosToThaw : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Special Instructions :', `${formData.specialInstructions ? formData.specialInstructions : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Allis/Stylet :', `${formData.antibioticNeeded ? formData.antibioticNeeded : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('ERA :', `${formData.eraTestDone ? formData.eraTestDone : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Comorbidities :', `${formData.comorbidities === 'OTHERS' ? formData.otherComorbidities || '' : formData.comorbidities || ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Medication :', `${formData.medication ? formData.medication : ''}`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          {showTables.medicationChart && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>MEDICATION CHART</h4>
              </div>

              <div>
                <table
                  style={{
                    marginBottom: '10px',
                    border: '1px solid black',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                  <thead>
                    <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                  </thead>
                  <tbody>
                    {medicationRows.map((row, i) => (
                      <tr key={i}>
                        {renderTableTD(row.sno)}
                        {renderTableTD(row.medication)}
                        {renderTableTD(row.dose)}
                        {renderTableTD(row.frequency)}
                        {renderTableTD(row.route)}
                        {renderTableTD(row.food)}
                        {renderTableTD(row.notes)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}



          <div style={{display: 'flex', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>FOOTER – GESTONE PAIN MANAGEMENT</h4>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <div>
              {[
                '1. Ice pack 5–10 min before & after injection',
                '2. Warm compress later for muscle relaxation',
                '3. Inject slowly; gentle massage helps',
                '4. Rotate both buttocks; avoid same site',
                '5. Mild Diclofenac gel if painful',
                '6. Report swelling, redness, or hard lump'
              ].map((item, index) => (
                <div key={index} style={{display: 'flex', marginBottom: '5px', paddingLeft: '10px'}} dangerouslySetInnerHTML={{__html: item}}></div>
              ))}
            </div>
          </div>

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>Advice:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice ? formData.advice : ''}</pre>
          </div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
